import { Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAccountContext } from "../../../strict/app/AccountResolver";
import { HomepageSparklineDay } from "../../../graphql/types";

import { ArrowRightIcon } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { CloudArrowDownIcon } from "@phosphor-icons/react/dist/csr/CloudArrowDown";
import { CloudArrowUpIcon } from "@phosphor-icons/react/dist/csr/CloudArrowUp";

import { AccordionColumns, NameAndEvent, SevenDaysSparkline } from "./Rows";

type TransferRowProps = {
  name: string;
  sparkline: HomepageSparklineDay[];
  isDark: boolean;
  sparklineFirstDate: string;
  transferStatus: { msg: string; status: string };
  type: "download" | "upload";
  artifactStatus: string;
  destination?: string;
  refreshData: () => Promise<void>;
  refreshing: boolean;
};

const TransferRow = ({
  name,
  sparkline,
  isDark,
  sparklineFirstDate,
  transferStatus,
  type,
  destination,
  artifactStatus,
  refreshData,
  refreshing,
}: TransferRowProps) => {
  const navigate = useNavigate();
  const { urlName } = useAccountContext();
  return (
    <AccordionColumns
      isDark={isDark}
      sx={{
        ".actionsGroup": {
          display: "none",
        },
        "&:hover": {
          ".actionsGroup": {
            display: "flex",
          },
        },
      }}
    >
      <Stack sx={{ padding: "12px", justifySelf: "center" }}>
        {type === "download" ? <CloudArrowDownIcon size="24px" /> : <CloudArrowUpIcon size="24px" />}
      </Stack>
      <Stack
        sx={{
          wordBreak: "break-word",
        }}
      >
        <NameAndEvent
          name={name}
          status={transferStatus}
          destination={destination}
          type={type}
          artifactStatus={artifactStatus}
          refreshData={refreshData}
          refreshing={refreshing}
        />
      </Stack>
      <div style={{ padding: "12px", alignSelf: "center" }}>
        <SevenDaysSparkline sparklines={sparkline} sparklineFirstDate={sparklineFirstDate} />
      </div>
      <div style={{ padding: "12px", alignSelf: "center" }}>
        <Button
          variant="text"
          color="secondary"
          size="xSmall"
          endIcon={<ArrowRightIcon />}
          onClick={() => navigate(`/app/${urlName}/homepage-details?name=${encodeURIComponent(name)}&type=${type}`)}
        >
          View
        </Button>
      </div>
    </AccordionColumns>
  );
};

export { TransferRow };
